import { PostGreSQLInterval } from 'api';

export function normalizePgInterval(interval?: PostGreSQLInterval | null): PostGreSQLInterval {
  return {
    seconds: interval?.seconds ?? 0,
    minutes: interval?.minutes ?? 0,
    hours: interval?.hours ?? 0,
    days: interval?.days ?? 0,
    weeks: interval?.weeks ?? 0,
    months: interval?.months ?? 0,
    years: interval?.years ?? 0,
  };
}

export default normalizePgInterval;
